<header class="saved-carts__header d-flex align-items-center px-2 py-3 p-lg-0">
  <h1 class="fs-2 fw-normal d-inline-flex align-items-center mb-0 mb-lg-4">
    {{ 'rrs.savedCart.wishlists' | cxTranslate }}
    <rrs-icon [icon]="iconTypeList.MAP_PIN" [size]="32" class="ms-2"></rrs-icon>
  </h1>
</header>
<rrs-saved-carts-list></rrs-saved-carts-list>
